<template>
    <router-link :to="{name: 'installation', params:{id: this.$route.params.id, idInst:installation.id}}" class="install wrap" :class="(gotFluide) ? '' : 'nofluide'">

        <p class="identification">
            <strong>{{ installation.nom }}</strong>
            <br>
             <span class="marque-modele" v-if="installation.marque && installation.modele">
                {{ installation.marque }} - <b>{{ installation.modele }}</b>
            </span>
        </p>

        <div class="infos-sup" v-if="gotFluide">
            <div class="btn refrigerant">
                <i class="icon-fluid"></i>
                {{ installation.fluide.nom }}
            </div>

            <div class="otagInstall" v-if="installation.i_tag !== null">
                <i class="icon-otag"></i>
                {{ installation.i_tag }}
            </div>

            <span class="charge-totale">
                CHARGE TOTALE <b>{{ installation.charge}} kg</b>
            </span>

        </div>

        <div v-else>
            <div class="otagInstall" v-if="installation.i_tag !== null">
                <i class="icon-otag"></i>
                {{ installation.i_tag }}
            </div>
        </div>

            <div class="icon-barre">
                <div class="tooltip-container" v-for="(alerte, index) in alertes" :key="index" @click.prevent.stop="toggleTooltip(index)">
                    <i class="fas fa-exclamation-triangle alert-icon" :style="{ color: alerte.color }"></i>
                    <div class="inst-tooltip" :class="{ show: openedTooltip === index }" v-html="alerte.tooltip"></div>
                </div>
            </div>
    </router-link>
</template>

<script>
import Installation from "../../js/models/Installation";

export default {
    data() {
        return {
            alertes: [],
            openedTooltip: null
        }
    },
    props: {
        installation: {

        }
    },
    computed: {
        gotFluide(){
            return (!_.isEmpty(this.installation.fluide));
        }
    },
    methods: {
        toggleTooltip(index) {
            this.openedTooltip = this.openedTooltip === index ? null : index;
        }
    },
    mounted() {
        Installation.getAlertes(this.installation).then(alertes => {
            let messages = [];
            for (const key in alertes) {

                if(key === 'periodique'){
                    messages.push({
                        tooltip: "Contrôle périodique <br>"+ (alertes[key] === "alert" ? 'Dépassé' : 'A Faire'),
                        color: alertes[key] === "alert" ? 'red' : 'orange',
                        message: 'Contrôle <br> périodique<br> ' + (alertes[key] === "alert" ? 'Dépassé' : 'A Faire')
                    })
                }

                if(key === "desp") {
                    messages.push({
                        tooltip: "Contrôle DESP <br>"+ (alertes[key] === "alert" ? 'Dépassé' : 'A Faire'),
                        color: alertes[key] === "alert" ? 'red' : 'orange',
                        message: 'Contrôle <br> DESP<br> ' + (alertes[key] === "alert" ? 'Dépassé' : 'A Faire')
                    })
                }

                if(key === 'maintenance'){
                    messages.push({
                        tooltip: "Maintenance préventive <br>" + (alertes[key] === "alert" ? 'Dépassé' : 'A Faire'),
                        color: alertes[key] === "alert" ? 'red' : 'orange',
                        message: 'Maintenance <br> Préventive<br> ' + (alertes[key] === "alert" ? 'Dépassé' : 'A Faire')
                    })
                }

                if(key === 'attestation'){
                    messages.push({
                        tooltip: "Attestation d\'entretien",
                        color: alertes[key] === "alert" ? 'red' : 'orange',
                        message: 'Attestation<br> d\'entretien ' + (alertes[key] === "alert" ? 'Dépassé' : 'A Faire')
                    })
                }

            }

            this.alertes = messages;
        })

    },
}
</script>

<style>
.list-installations .install {
    position: relative;
    min-height: 95px;
    margin-bottom: 5px;
    background-color: #eeeeee;
    padding: 8px 50px 8px 10px;
    width: 100%;
    display: block;
}

.list-installations .install:after {
    content: '\e909';
    font-family: 'fi360' !important;
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    font-size: 3.3rem;
    position: absolute;
    right: 10px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    color: #5698d2;
}

.list-installations .install .otagInstall {
    background-color: #EA5E0B;
    padding: 7px 5px;
    color: white;
    font-weight: bold;
    margin-left: 5px;
    min-height: 35px;
    border-radius: 5px;
    max-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.list-installations .install.nofluide {
    min-height: 70px;
}

.list-installations .install.off {
    display: none;
}

.list-installations .install p.identification {
    color: #666;
    font-size: 1.6rem;
    font-weight: 400;
    line-height: 1.2;
    margin-bottom: 10px;
}

.list-installations .install p.identification strong {
    color: #000;
    margin-bottom: 5px;
    font-size: 2rem;
    font-weight: 400;
}

.list-installations .install p.identification b {
    font-weight: 700;
}

.list-installations .install .actions a.btn {
    /*display: inline-flex;*/
    float: right;
}

.list-installations .install .infos-sup {
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    -ms-align-items: center;
    align-items: center;
    flex-wrap: wrap;
}

.list-installations .install .btn.refrigerant {
    line-height: 2;
}

.list-installations .install .charge-totale {
    margin-left: 15px;
    font-size: 1.4rem;
}

.list-installations .install .charge-totale b {
    display: block;
    font-size: 1.6rem;
}

.list-installations .install .icon-barre {
    position: relative;
    display: flex;
}

.list-installations .install .alert-icon {
    font-size: 35px;
}

.list-installations .install .tooltip-container {
    display: inline-block;
    margin-right: 10px;
    padding: 5px;
}

.list-installations .install .inst-tooltip {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    max-width: 200px;
    background-color: #333;
    color: #fff;
    padding: 10px;
    border-radius: 5px;
    z-index: 2;
    white-space: normal;
    text-align: center;
}

.list-installations .install .inst-tooltip.show {
    display: block;
}

@media (hover: hover) {
    .list-installations .install .tooltip-container:hover .inst-tooltip {
        display: block;
    }
}
</style>



// WEBPACK FOOTER //
// InstallationItem.vue?18033315